// [AIV_SHORT]  Build version: 12.0.2 - Wednesday, August 19th, 2020, 6:38:31 PM  
 (function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["GenesysCloudStreamingClient"] = factory();
	else
		root["GenesysCloudStreamingClient"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/client.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/client.js":
/*!***********************!*\
  !*** ./src/client.js ***!
  \***********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Client; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/slicedToArray */ "@babel/runtime/helpers/slicedToArray");
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "@babel/runtime/helpers/classCallCheck");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "@babel/runtime/helpers/createClass");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _stanzaio_light__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./stanzaio-light */ "./src/stanzaio-light.js");
/* harmony import */ var _notifications__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./notifications */ "./src/notifications.js");
/* harmony import */ var _reconnector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./reconnector */ "./src/reconnector.js");
/* harmony import */ var _ping__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ping */ "./src/ping.js");
/* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./polyfills */ "./src/polyfills.js");
/* harmony import */ var _polyfills__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_polyfills__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils */ "./src/utils.js");
/* harmony import */ var genesys_cloud_streaming_client_webrtc_sessions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! genesys-cloud-streaming-client-webrtc-sessions */ "genesys-cloud-streaming-client-webrtc-sessions");
/* harmony import */ var genesys_cloud_streaming_client_webrtc_sessions__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(genesys_cloud_streaming_client_webrtc_sessions__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var limiter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! limiter */ "limiter");
/* harmony import */ var limiter__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(limiter__WEBPACK_IMPORTED_MODULE_10__);
 // src imports









 // extension imports

 // external imports


var extensions = {
  ping: _ping__WEBPACK_IMPORTED_MODULE_6__["default"],
  reconnector: _reconnector__WEBPACK_IMPORTED_MODULE_5__["default"],
  notifications: _notifications__WEBPACK_IMPORTED_MODULE_4__["default"],
  webrtcSessions: genesys_cloud_streaming_client_webrtc_sessions__WEBPACK_IMPORTED_MODULE_9___default.a
};

function stanzaioOptions(config) {
  var wsHost = config.host.replace(/\/$/, '');
  var stanzaOptions = {
    jid: config.jid,
    credentials: {
      username: config.jid,
      password: "authKey:".concat(config.authToken)
    },
    wsURL: "".concat(wsHost, "/stream/channels/").concat(config.channelId),
    transport: 'websocket'
  };
  return stanzaOptions;
}

var HARD_RECONNECT_THRESHOLD = 2; // from https://stackoverflow.com/questions/38552003/how-to-decode-jwt-token-in-javascript

function parseJwt(token) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
  return JSON.parse(jsonPayload);
}

function stanzaOptionsJwt(config) {
  var jwt = parseJwt(config.jwt);
  var jidDomain;

  try {
    jidDomain = jwt.data.jid.split('@')[1].replace('conference.', '');
  } catch (e) {
    throw new Error('failed to parse jid');
  }

  var wsHost = config.host.replace(/\/$/, '');
  var stanzaOptions = {
    wsURL: "".concat(wsHost, "/stream/jwt/").concat(config.jwt),
    transport: 'websocket',
    server: jidDomain,
    sasl: ['anonymous']
  };
  return stanzaOptions;
}

var REMAPPED_EVENTS = {
  'connected': 'session:started',
  '_connected': 'connected',
  'disconnected': 'session:end',
  '_disconnected': 'disconnected'
};
var APP_VERSION = '12.0.2';

var Client = /*#__PURE__*/function () {
  function Client(options) {
    var _this = this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Client);

    var stanzaio = Object(_stanzaio_light__WEBPACK_IMPORTED_MODULE_3__["createClient"])({});
    this._stanzaio = stanzaio;
    this.connected = false;
    this.autoReconnect = true;
    this.reconnectOnNoLongerSubscribed = options.reconnectOnNoLongerSubscribed !== false;
    this.logger = options.logger || console;
    this.leakyReconnectTimer = null;
    this.hardReconnectCount = 0; // 10 minutes

    this.reconnectLeakTime = 1000 * 60 * 10;
    this.deadChannels = [];
    this.config = {
      host: options.host,
      apiHost: options.apiHost || options.host.replace('wss://streaming.', ''),
      authToken: options.authToken,
      jwt: options.jwt,
      jid: options.jid,
      channelId: null // created on connect

    };
    this.on('_disconnected', function (event) {
      _this.connected = false;

      _this._ping.stop(); // example url: "wss://streaming.inindca.com/stream/channels/streaming-cgr4iprj4e8038aluvgmdn74fr"


      var channelIdRegex = /stream\/channels\/([^/]+)/;
      var url = event && event.conn && event.conn.url || '';
      var matches = url.match(channelIdRegex);
      var channelId = 'failed to parse';

      if (matches) {
        channelId = matches[1];
      }

      _this.logger.info('Streaming client disconnected.', {
        channelId: channelId
      });

      if (!event) {
        if (_this.autoReconnect) {
          _this.logger.warn('Streaming client disconnected without an event notification. Not able to reconnect.');
        }

        return;
      }

      if (_this.autoReconnect && !_this.deadChannels.includes(channelId)) {
        _this.logger.info('Streaming client disconnected unexpectedly. Attempting to auto reconnect.', {
          channelId: channelId
        });

        _this._reconnector.start();
      }
    }); // remapped session:started

    this.on('connected', function (event) {
      _this.streamId = event.resource;

      _this._ping.start();

      _this.connected = true;

      _this._reconnector.stop();
    }); // remapped session:end

    this.on('disconnected', function (event) {
      _this._ping.stop();
    });
    this.on('sasl:failure', function (err) {
      var errMessage = 'Authentication failed connecting to streaming service';
      err = Object.assign(err || {}, {
        channelId: _this.config.channelId
      });

      _this.logger.error(errMessage, err);

      if (!err || err.condition !== 'temporary-auth-failure') {
        _this._ping.stop();

        _this.autoReconnect = false;

        _this.disconnect();
      }
    });
    this.on('notify:v2.system.no_longer_subscribed*', function (event, data) {
      _this._ping.stop();

      var channelId = data.eventBody.channelId;

      _this.deadChannels.push(channelId);

      if (channelId !== _this.config.channelId) {
        _this.logger.warn('received no_longer_subscribed event for a non active channelId');

        return;
      }

      if (_this.hardReconnectCount >= HARD_RECONNECT_THRESHOLD) {
        _this.logger.error("no_longer_subscribed has been called ".concat(_this.hardReconnectCount, " times and the threshold is ").concat(HARD_RECONNECT_THRESHOLD, ", not attempting to reconnect\n          channelId: ").concat(_this.config.channelId));

        _this.cleanupLeakTimer();

        return;
      }

      _this.logger.info('no_longer_subscribed received');

      if (!_this.reconnectOnNoLongerSubscribed) {
        _this.logger.info('`reconnectOnNoLongerSubscribed` is false, not attempting to reconnect streaming client');

        return;
      }

      _this.logger.info('streaming client attempting to reconnect');

      _this.hardReconnectCount++;

      if (!_this.leakyReconnectTimer) {
        _this.leakyReconnectTimer = setInterval(function () {
          if (_this.hardReconnectCount > 0) {
            _this.hardReconnectCount--;
          } else {
            _this.cleanupLeakTimer();
          }
        }, _this.reconnectLeakTime);
      }

      _this._reconnector.hardReconnect();
    });
    Object.keys(extensions).forEach(function (extensionName) {
      var extension = new extensions[extensionName](_this, options);

      if (typeof extension.handleIq === 'function') {
        stanzaio.on('iq', extension.handleIq.bind(extension));
      }

      if (typeof extension.handleMessage === 'function') {
        stanzaio.on('message', extension.handleMessage.bind(extension));
      }

      if (!extension.tokenBucket) {
        // default rate limit
        // 20 stanzas per 1000 ms,
        // adding up to 25 stanzas over the course of the 1000ms
        // starting with 20 stanzas
        // = 45 stanzas max per 1000 ms
        // = 70 stanzas max per 2000 ms
        extension.tokenBucket = new limiter__WEBPACK_IMPORTED_MODULE_10__["TokenBucket"](20, 25, 1000);
        extension.tokenBucket.content = 25;
      }

      if (typeof extension.on === 'function') {
        extension.on('send', function (data) {
          var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          return extension.tokenBucket.removeTokens(1, function () {
            if (message === true) {
              return stanzaio.sendMessage(data);
            }

            return stanzaio.sendIq(data);
          });
        });
      }

      _this[extensionName] = extension.expose;
      _this["_".concat(extensionName)] = extension;
    });
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Client, [{
    key: "cleanupLeakTimer",
    value: function cleanupLeakTimer() {
      clearInterval(this.leakyReconnectTimer);
      this.leakyReconnectTimer = null;
    }
  }, {
    key: "on",
    value: function on(eventName) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (REMAPPED_EVENTS[eventName]) {
        var _this$_stanzaio;

        (_this$_stanzaio = this._stanzaio).on.apply(_this$_stanzaio, [REMAPPED_EVENTS[eventName]].concat(args));
      } else {
        var _this$_stanzaio2;

        (_this$_stanzaio2 = this._stanzaio).on.apply(_this$_stanzaio2, [eventName].concat(args));
      }

      return this;
    }
  }, {
    key: "once",
    value: function once(eventName) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (REMAPPED_EVENTS[eventName]) {
        var _this$_stanzaio3;

        (_this$_stanzaio3 = this._stanzaio).once.apply(_this$_stanzaio3, [REMAPPED_EVENTS[eventName]].concat(args));
      } else {
        var _this$_stanzaio4;

        (_this$_stanzaio4 = this._stanzaio).once.apply(_this$_stanzaio4, [eventName].concat(args));
      }

      return this;
    }
  }, {
    key: "off",
    value: function off(eventName) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      if (REMAPPED_EVENTS[eventName]) {
        var _this$_stanzaio5;

        (_this$_stanzaio5 = this._stanzaio).off.apply(_this$_stanzaio5, [REMAPPED_EVENTS[eventName]].concat(args));
      } else {
        var _this$_stanzaio6;

        (_this$_stanzaio6 = this._stanzaio).off.apply(_this$_stanzaio6, [eventName].concat(args));
      }

      return this;
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this2 = this;

      this.logger.info('streamingClient.disconnect was called');
      return Object(_utils__WEBPACK_IMPORTED_MODULE_8__["timeoutPromise"])(function (resolve) {
        _this2._stanzaio.once('disconnected', resolve);

        _this2.autoReconnect = false;

        _this2._stanzaio.disconnect();
      }, 1000, 'disconnecting streaming service');
    }
  }, {
    key: "reconnect",
    value: function reconnect() {
      var _this3 = this;

      this.logger.info('streamingClient.reconnect was called');
      return Object(_utils__WEBPACK_IMPORTED_MODULE_8__["timeoutPromise"])(function (resolve) {
        _this3._stanzaio.once('session:started', resolve); // trigger a stop on the underlying connection, but allow reconnect


        _this3.autoReconnect = true;

        _this3._stanzaio.disconnect();
      }, 10 * 1000, 'reconnecting streaming service');
    }
  }, {
    key: "connect",
    value: function connect() {
      var _this4 = this;

      this.logger.info('streamingClient.connect was called');

      if (this.config.jwt) {
        return Object(_utils__WEBPACK_IMPORTED_MODULE_8__["timeoutPromise"])(function (resolve) {
          _this4.once('connected', resolve);

          _this4._stanzaio.connect(stanzaOptionsJwt(_this4.config));
        }, 10 * 1000, 'connecting to streaming service with jwt');
      }

      var jidPromise;

      if (this.config.jid) {
        jidPromise = Promise.resolve(this.config.jid);
      } else {
        var _opts = {
          method: 'get',
          host: this.config.apiHost,
          authToken: this.config.authToken
        };
        jidPromise = Object(_utils__WEBPACK_IMPORTED_MODULE_8__["requestApi"])('users/me', _opts).then(function (res) {
          return res.body.chat.jabberId;
        });
      }

      var opts = {
        method: 'post',
        host: this.config.apiHost,
        authToken: this.config.authToken,
        logger: this.logger
      };
      var channelPromise = Object(_utils__WEBPACK_IMPORTED_MODULE_8__["requestApi"])('notifications/channels?connectionType=streaming', opts).then(function (res) {
        return res.body.id;
      });
      return Promise.all([jidPromise, channelPromise]).then(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 2),
            jid = _ref2[0],
            channelId = _ref2[1];

        _this4.config.jid = jid;
        _this4.config.channelId = channelId;
        _this4.autoReconnect = true;
        return Object(_utils__WEBPACK_IMPORTED_MODULE_8__["timeoutPromise"])(function (resolve) {
          _this4.once('connected', resolve);

          _this4._stanzaio.connect(stanzaioOptions(_this4.config));
        }, 10 * 1000, 'connecting to streaming service', {
          jid: jid,
          channelId: channelId
        });
      });
    }
  }], [{
    key: "extend",
    value: function extend(namespace, extender) {
      if (extensions[namespace]) {
        throw new Error("Cannot register already existing namespace ".concat(namespace));
      }

      extensions[namespace] = extender;
    }
  }, {
    key: "version",
    get: function get() {
      return APP_VERSION;
    }
  }]);

  return Client;
}();



/***/ }),

/***/ "./src/notifications.js":
/*!******************************!*\
  !*** ./src/notifications.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Notification; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "@babel/runtime/helpers/defineProperty");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "@babel/runtime/helpers/classCallCheck");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "@babel/runtime/helpers/createClass");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "@babel/runtime/helpers/toConsumableArray");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils */ "./src/utils.js");






var debounce = __webpack_require__(/*! debounce-promise */ "debounce-promise");

var PUBSUB_HOST_DEFAULT = 'notifications.mypurecloud.com';
var MAX_SUBSCRIBABLE_TOPICS = 1000;
var DROPPED_TOPICS_DISPLAY_COUNT = 20;
var DEFAULT_PRIORITY = 0;

function mergeAndDedup(arr1, arr2) {
  return [].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default()(arr1), _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_3___default()(arr2)).filter(function (t, i, arr) {
    return arr.indexOf(t) === i;
  });
}

var Notification = /*#__PURE__*/function () {
  function Notification(client) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Notification);

    this.subscriptions = {};
    this.bulkSubscriptions = {};
    this.topicPriorities = {};
    this.client = client;
    client.on('pubsub:event', this.pubsubEvent.bind(this));
    client.on('connected', this.subscriptionsKeepAlive.bind(this));
    this.debouncedResubscribe = debounce(this.resubscribe.bind(this), 100);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Notification, [{
    key: "topicHandlers",
    value: function topicHandlers(topic) {
      if (!this.subscriptions[topic]) {
        this.subscriptions[topic] = [];
      }

      return this.subscriptions[topic];
    }
  }, {
    key: "pubsubEvent",
    value: function pubsubEvent(msg) {
      var topic = msg.event.updated.node;
      var payload = msg.event.updated.published[0].json;
      var handlers = this.topicHandlers(topic);

      this.client._stanzaio.emit('notify', {
        topic: topic,
        data: payload
      });

      this.client._stanzaio.emit("notify:".concat(topic), payload);

      handlers.forEach(function (handler) {
        handler(payload);
      });
    }
  }, {
    key: "xmppSubscribe",
    value: function xmppSubscribe(topic, callback) {
      var _this = this;

      if (this.topicHandlers(topic).length !== 0 || this.bulkSubscriptions[topic]) {
        return callback();
      }

      var subscribe = function subscribe() {
        return _this.client._stanzaio.subscribeToNode(_this.pubsubHost, topic, callback);
      };

      if (this.client.connected) {
        subscribe();
      } else {
        this.client.once('connected', function () {
          subscribe();
        });
      }
    }
  }, {
    key: "xmppUnsubscribe",
    value: function xmppUnsubscribe(topic, callback) {
      var _this2 = this;

      if (this.topicHandlers(topic).length !== 0 || this.bulkSubscriptions[topic]) {
        return callback();
      }

      var unsubscribe = function unsubscribe() {
        return _this2.client._stanzaio.unsubscribeFromNode(_this2.pubsubHost, topic, callback);
      };

      if (this.client.connected) {
        unsubscribe();
      } else {
        this.client.once('connected', function () {
          unsubscribe();
        });
      }
    }
  }, {
    key: "mapCombineTopics",
    value: function mapCombineTopics(topics) {
      var _this3 = this;

      var prefixes = {};
      var precombinedTopics = [];
      var uncombinedTopics = [];
      topics.forEach(function (t) {
        if (t.includes('?')) {
          precombinedTopics.push({
            id: t
          });
        } else {
          uncombinedTopics.push(t);
        }
      });
      uncombinedTopics.map(function (t) {
        var split = t.split('.');
        var postfix = split.splice(split.length - 1);
        var prefix = split.join('.');
        return {
          prefix: prefix,
          postfix: postfix
        };
      }).forEach(function (t) {
        if (prefixes[t.prefix]) {
          prefixes[t.prefix].push(t.postfix);
        } else {
          prefixes[t.prefix] = [t.postfix];
        }
      });
      var combinedTopics = []; // Max length of 200 in topic names
      // so recursively break them up if the combined length exceeds 200

      var combineTopics = function combineTopics(prefix, postFixes) {
        var delimiter = postFixes.length === 1 ? '.' : '?';
        var id = "".concat(prefix).concat(delimiter).concat(postFixes.join('&'));

        if (id.length < 200) {
          combinedTopics.push({
            id: id
          });
        } else if (postFixes.length === 1) {
          _this3.client.logger.error('Refusing to attempt topic with length > 200', id);
        } else {
          combineTopics(prefix, postFixes.slice(0, postFixes.length / 2));
          combineTopics(prefix, postFixes.slice(postFixes.length / 2));
        }
      };

      Object.keys(prefixes).forEach(function (prefix) {
        var postFixes = prefixes[prefix];
        combineTopics(prefix, postFixes);
      });
      var allTopics = combinedTopics.concat(precombinedTopics);
      return this.truncateTopicList(this.prioritizeTopicList(allTopics));
    }
  }, {
    key: "prioritizeTopicList",
    value: function prioritizeTopicList(topics) {
      var _this4 = this;

      topics.sort(function (topicA, topicB) {
        return _this4.getTopicPriority(topicB.id) - _this4.getTopicPriority(topicA.id);
      });
      return topics;
    }
  }, {
    key: "getTopicPriority",
    value: function getTopicPriority(topic) {
      var returnDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      var _this$getTopicParts = this.getTopicParts(topic),
          prefix = _this$getTopicParts.prefix,
          postfixes = _this$getTopicParts.postfixes;

      var oldPriorities = this.topicPriorities[prefix];
      var matches = oldPriorities && Object.keys(oldPriorities).filter(function (p) {
        return postfixes.includes(p);
      }).map(function (p) {
        return oldPriorities[p];
      });
      var priority = matches && matches.length && matches.reduce(function (max, current) {
        return current > max ? current : max;
      });
      return returnDefault ? priority || DEFAULT_PRIORITY : priority;
    }
  }, {
    key: "truncateTopicList",
    value: function truncateTopicList(topics) {
      var keptTopics = topics.slice(0, MAX_SUBSCRIBABLE_TOPICS);

      if (topics.length > MAX_SUBSCRIBABLE_TOPICS) {
        var droppedTopics = topics.slice(MAX_SUBSCRIBABLE_TOPICS);

        if (droppedTopics.length > DROPPED_TOPICS_DISPLAY_COUNT) {
          var length = droppedTopics.length - DROPPED_TOPICS_DISPLAY_COUNT;
          droppedTopics = droppedTopics.slice(DROPPED_TOPICS_DISPLAY_COUNT);
          droppedTopics.push("...and ".concat(length, " more"));
        }

        this.client.logger.warn('Too many topics to subscribe to; truncating extra topics', {
          droppedTopics: droppedTopics
        });
      }

      return keptTopics;
    }
  }, {
    key: "bulkSubscribe",
    value: function bulkSubscribe(topics, options) {
      var requestOptions = {
        method: options.replace ? 'put' : 'post',
        host: this.client.config.apiHost,
        authToken: this.client.config.authToken,
        data: JSON.stringify(this.mapCombineTopics(topics)),
        logger: this.client.logger
      };
      var channelId = this.client.config.channelId;
      return Object(_utils__WEBPACK_IMPORTED_MODULE_4__["requestApi"])("notifications/channels/".concat(channelId, "/subscriptions"), requestOptions);
    }
  }, {
    key: "createSubscription",
    value: function createSubscription(topic, handler) {
      var _this5 = this;

      var topics = Object(_utils__WEBPACK_IMPORTED_MODULE_4__["splitIntoIndividualTopics"])(topic);
      topics.forEach(function (t) {
        var handlers = _this5.topicHandlers(t);

        if (!handlers.includes(handler)) {
          handlers.push(handler);
        }
      });
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription(topic, handler) {
      var _this6 = this;

      var topics = Object(_utils__WEBPACK_IMPORTED_MODULE_4__["splitIntoIndividualTopics"])(topic);
      topics.forEach(function (t) {
        var handlers = _this6.topicHandlers(t);

        var handlerIndex = handlers.indexOf(handler);

        if (handlerIndex > -1) {
          handlers.splice(handlerIndex, 1);
        }
      });
    }
  }, {
    key: "removeTopicPriority",
    value: function removeTopicPriority(topic) {
      var _this7 = this;

      if (this.getTopicPriority(topic, false)) {
        var _this$getTopicParts2 = this.getTopicParts(topic),
            prefix = _this$getTopicParts2.prefix,
            postfixes = _this$getTopicParts2.postfixes;

        postfixes.forEach(function (postfix) {
          delete _this7.topicPriorities[prefix][postfix];
        });

        if (!Object.keys(this.topicPriorities[prefix]).length) {
          delete this.topicPriorities[prefix];
        }
      }
    }
  }, {
    key: "getActiveIndividualTopics",
    value: function getActiveIndividualTopics() {
      var _this8 = this;

      var activeTopics = [];
      var topics = Object.keys(this.subscriptions);
      topics.forEach(function (topic) {
        if (topic === 'streaming-subscriptions-expiring') {
          return; // this doesn't need subscribed
        }

        var handlers = _this8.topicHandlers(topic);

        if (handlers.length > 0) {
          activeTopics.push(topic);
        }
      });
      return activeTopics;
    }
  }, {
    key: "resubscribe",
    value: function resubscribe() {
      var topicsToResubscribe = mergeAndDedup(Object.keys(this.bulkSubscriptions), this.getActiveIndividualTopics());

      if (topicsToResubscribe.length === 0) {
        return Promise.resolve();
      }

      return this.bulkSubscribe(topicsToResubscribe, {
        replace: true
      });
    }
  }, {
    key: "subscriptionsKeepAlive",
    value: function subscriptionsKeepAlive() {
      var _this9 = this;

      var topic = 'streaming-subscriptions-expiring';

      if (this.topicHandlers(topic).length === 0) {
        this.createSubscription(topic, function () {
          _this9.client.logger.info("".concat(topic, " - Triggering resubscribe."));

          _this9.resubscribe()["catch"](function (err) {
            var msg = 'Error resubscribing to topics';

            _this9.client.logger.error(msg, err);

            _this9.client._stanzaio.emit('pubsub:error', {
              msg: msg,
              err: err
            });
          });
        });
      }
    }
  }, {
    key: "getTopicParts",
    value: function getTopicParts(topic) {
      var isCombined = topic.includes('?');
      var separator = isCombined ? '?' : '.';
      var split = topic.split(separator);
      var postfix = isCombined ? split[1] : split.splice(split.length - 1);
      var prefix = isCombined ? split[0] : split.join('.');
      var postfixes = [];

      if (isCombined) {
        postfixes = postfix.split('&');
      } else {
        postfixes = postfix;
      }

      return {
        prefix: prefix,
        postfixes: postfixes
      };
    }
  }, {
    key: "setTopicPriorities",
    value: function setTopicPriorities() {
      var _this10 = this;

      var priorities = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      Object.keys(priorities).forEach(function (priority) {
        var topicParts = _this10.getTopicParts(priority);

        var oldPriorities = _this10.topicPriorities[topicParts.prefix];
        var newPriority = priorities[priority];

        if (oldPriorities) {
          topicParts.postfixes.forEach(function (postfix) {
            var oldPriority = oldPriorities[postfix];

            if (oldPriority && oldPriority < newPriority || !oldPriority) {
              oldPriorities[postfix] = newPriority;
            }
          });
        } else {
          var newTopics = topicParts.postfixes.reduce(function (newTopics, p) {
            newTopics[p] = newPriority;
            return newTopics;
          }, {});
          _this10.topicPriorities[topicParts.prefix] = newTopics;
        }
      });
    }
  }, {
    key: "pubsubHost",
    get: function get() {
      try {
        var host = this.client.config.apiHost.replace(/http(s?):\/\//, '');
        return "notifications.".concat(host);
      } catch (e) {
        return PUBSUB_HOST_DEFAULT;
      }
    }
  }, {
    key: "expose",
    get: function get() {
      return {
        subscribe: function (topic, handler, immediate, priority) {
          var _this11 = this;

          if (priority) {
            this.setTopicPriorities(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()({}, topic, priority));
          }

          var promise;

          if (!immediate) {
            // let this and any other subscribe/unsubscribe calls roll in, then trigger a whole resubscribe
            promise = this.debouncedResubscribe();
          } else {
            promise = new Promise(function (resolve, reject) {
              _this11.xmppSubscribe(topic, function (err) {
                if (err) {
                  reject(err);
                } else {
                  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = arguments[_key];
                  }

                  resolve.apply(void 0, args);
                }
              });
            });
          }

          if (handler) {
            this.createSubscription(topic, handler);
          } else {
            this.bulkSubscriptions[topic] = true;
          }

          return promise;
        }.bind(this),
        unsubscribe: function (topic, handler, immediate) {
          var _this12 = this;

          if (handler) {
            this.removeSubscription(topic, handler);
          } else {
            delete this.bulkSubscriptions[topic];
          }

          this.removeTopicPriority(topic);

          if (!immediate) {
            // let this and any other subscribe/unsubscribe calls roll in, then trigger a whole resubscribe
            return this.debouncedResubscribe();
          }

          return new Promise(function (resolve, reject) {
            _this12.xmppUnsubscribe(topic, function (err) {
              if (err) {
                reject(err);
              } else {
                for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                  args[_key2 - 1] = arguments[_key2];
                }

                resolve.apply(void 0, args);
              }
            });
          });
        }.bind(this),
        bulkSubscribe: function (topics) {
          var _this13 = this;

          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            replace: false,
            force: false
          };
          var priorities = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          this.setTopicPriorities(priorities);
          var toSubscribe = mergeAndDedup(topics, []);

          if (options.replace && !options.force) {
            // if this is a bulk subscription, but not a forcible one, keep all individual subscriptions
            toSubscribe = mergeAndDedup(toSubscribe, this.getActiveIndividualTopics());
          } else if (options.force) {
            // if it's a forcible bulk subscribe, wipe out individual subscriptions
            this.subscriptions = {};
          }

          return this.bulkSubscribe(toSubscribe, options).then(function () {
            if (options.replace) {
              _this13.bulkSubscriptions = {};
            }

            topics.forEach(function (topic) {
              _this13.bulkSubscriptions[topic] = true;
            });
          });
        }.bind(this)
      };
    }
  }]);

  return Notification;
}();



/***/ }),

/***/ "./src/ping.js":
/*!*********************!*\
  !*** ./src/ping.js ***!
  \*********************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


var DEFAULT_PING_INTERVAL = 10 * 1000;
var DEFAULT_MAXIMUM_FAILED_PINGS_BEFORE_DISCONNECT = 1;
/* harmony default export */ __webpack_exports__["default"] = (function (client, options) {
  options = options || {};
  var pingInterval = options.pingInterval || DEFAULT_PING_INTERVAL;
  var failedPingsBeforeDisconnect = options.failedPingsBeforeDisconnect || DEFAULT_MAXIMUM_FAILED_PINGS_BEFORE_DISCONNECT;
  var numberOfFailedPings = 0;
  var pingIntervalId = null;

  function pingCallback(error, response) {
    if (response && !error) {
      numberOfFailedPings = 0;
    } else {
      var info = {
        channelId: client.config.channelId,
        jid: client._stanzaio.jid.full
      };
      client.logger.warn('Missed a ping.', Object.assign({
        error: error
      }, info));

      if (++numberOfFailedPings > failedPingsBeforeDisconnect) {
        clearInterval(pingIntervalId);
        client.logger.error('Missed too many pings, disconnecting', Object.assign({
          numberOfFailedPings: numberOfFailedPings
        }, info));

        client._stanzaio.sendStreamError({
          text: 'too many missed pongs',
          condition: 'connection-timeout'
        });
      }
    }
  }

  function performPing() {
    client._stanzaio.ping(options.jid, pingCallback);
  }

  return {
    start: function start() {
      if (pingIntervalId === null) {
        pingIntervalId = setInterval(performPing, pingInterval);
      }
    },
    stop: function stop() {
      if (pingIntervalId !== null) {
        clearInterval(pingIntervalId);
        pingIntervalId = null;
      }
    }
  };
});

/***/ }),

/***/ "./src/polyfills.js":
/*!**************************!*\
  !*** ./src/polyfills.js ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/* istanbul ignore file */
if (!global) {
  Object.defineProperty(window, 'crypto', {
    value: window.crypto || window.msCrypto,
    writable: false,
    configurable: false
  });
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./src/reconnector.js":
/*!****************************!*\
  !*** ./src/reconnector.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Reconnector; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "@babel/runtime/helpers/classCallCheck");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "@babel/runtime/helpers/createClass");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);





var backoff = __webpack_require__(/*! backoff-web */ "backoff-web");

var Reconnector = /*#__PURE__*/function () {
  function Reconnector(client) {
    var _this = this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Reconnector);

    this.client = client;
    this.backoff = backoff.exponential({
      randomisationFactor: 0.2,
      initialDelay: 250,
      maxDelay: 5000,
      factor: 2
    });
    this.backoff.failAfter(10);
    this.backoff.on('ready', function (number, delay) {
      if (_this.client.connected) {
        _this.client.logger.debug('Backoff ready, client already connected');

        return;
      }

      if (_this.client._stanzaio.transport && _this.client._stanzaio.transport.conn) {
        var conn = _this.client._stanzaio.transport.conn;

        if (conn.readyState <= 1) {
          if (conn.readyState === 1) {
            _this.client.logger.debug('Backoff ready, client not connected, but has websocket open');
          }

          if (conn.readyState === 0) {
            _this.client.logger.debug('Backoff ready, client not connected, but has websocket pending');
          }

          _this.backoff.backoff();

          return;
        }
      }

      _this.client.logger.debug('Backoff ready, attempting reconnect');

      _this.client._stanzaio.connect();

      _this.backoff.backoff();
    });
    this.backoff.on('fail', function () {
      _this.hardReconnect();
    }); // self bound methods so we can clean up the handlers

    this._cleanupReconnect = this.cleanupReconnect.bind(this);
    this.client.on('connected', function () {
      _this._hasConnected = true;

      _this._cleanupReconnect();
    }); // disable reconnecting when there's an auth failure

    this.client.on('sasl:failure', function (err) {
      var temporaryFailure = err && err.condition === 'temporary-auth-failure';
      var channelExpired = _this._hasConnected && err && err.condition === 'not-authorized';

      if (channelExpired) {
        _this.hardReconnect();
      } else if (temporaryFailure) {
        _this.client.logger.info('Temporary auth failure, continuing reconnect attempts');
      } else {
        _this.client.logger.error('Critical error reconnecting; stopping automatic reconnect', err);

        _this._cleanupReconnect();
      }
    });
    var stanzaio = this.client._stanzaio;
    stanzaio.disco.addFeature('urn:xmpp:cxfr');
    var CxfrStanza = stanzaio.stanzas.define({
      name: 'cxfr',
      namespace: 'urn:xmpp:cxfr',
      tags: ['cxfr'],
      element: 'query',
      fields: {
        domain: stanzaio.stanzas.utils.textSub('urn:xmpp:cxfr', 'domain'),
        server: stanzaio.stanzas.utils.textSub('urn:xmpp:cxfr', 'server')
      }
    });
    stanzaio.stanzas.extendIQ(CxfrStanza);
    this.client.on('iq:set:cxfr', function () {
      // After 10 minutes, reconnect automatically
      var timeout = setTimeout(_this.client.reconnect, 10 * 60 * 1000); // If no `pending` response received from app, proceed with reconnect

      var failureTimeout = setTimeout(function () {
        clearTimeout(timeout);

        _this.client.reconnect();
      }, 1000); // send request to app to reconnect. app can say `pending` to allow for max 1 hour
      // delay in reconnect, and/or `done` to proceed with reconnect immediately

      _this.client._stanzaio.emit('requestReconnect', function (response) {
        if (response.pending === true) {
          clearTimeout(failureTimeout);
        }

        if (response.done) {
          clearTimeout(failureTimeout);
          clearTimeout(timeout);

          _this.client.reconnect();
        }
      });
    });
    this._backoffActive = false;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Reconnector, [{
    key: "hardReconnect",
    value: function hardReconnect() {
      this.client.logger.info('Attempting to reconnect with new channel.');

      this._cleanupReconnect();

      this._hasConnected = false;
      this.client.connect();
    }
  }, {
    key: "cleanupReconnect",
    value: function cleanupReconnect() {
      this.backoff.reset();
      this._backoffActive = false;
    }
  }, {
    key: "start",
    value: function start() {
      if (this._backoffActive) {
        return;
      }

      this.client._stanzaio.connect();

      this.backoff.backoff();
      this._backoffActive = true;
    }
  }, {
    key: "stop",
    value: function stop() {
      this.backoff.reset();
      this._backoffActive = false;
    }
  }]);

  return Reconnector;
}();



/***/ }),

/***/ "./src/request-logger.js":
/*!*******************************!*\
  !*** ./src/request-logger.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports = module.exports = function (logger, data) {
  logger = logger || console;
  data = data || {};
  return attachSuperagentLogger.bind(null, logger, data);
};

function attachSuperagentLogger(logger, data, req) {
  var start = new Date().getTime();
  var timestamp = new Date().toISOString();
  var method = req.method;
  logger.debug("request: ".concat(method.toUpperCase(), " ").concat(req.url), {
    timestamp: timestamp,
    data: data
  });
  req.on('response', function (res) {
    var now = new Date().toISOString();
    var status = res.status;
    var elapsed = now - start + 'ms';
    var correlationId = res.headers['inin-correlation-id'];
    var body = JSON.stringify(res.body);
    logger.debug("response: ".concat(method.toUpperCase(), " ").concat(req.url), {
      now: now,
      status: status,
      elapsed: elapsed,
      correlationId: correlationId,
      body: body
    });
  });
}

/***/ }),

/***/ "./src/stanzaio-light.js":
/*!*******************************!*\
  !*** ./src/stanzaio-light.js ***!
  \*******************************/
/*! exports provided: JID, Client, getActualFunction, createClient */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActualFunction", function() { return getActualFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createClient", function() { return createClient; });
/* harmony import */ var stanza_plugins_disco__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! stanza/plugins/disco */ "stanza/plugins/disco");
/* harmony import */ var stanza_plugins_disco__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(stanza_plugins_disco__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var stanza_plugins_extdisco__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! stanza/plugins/extdisco */ "stanza/plugins/extdisco");
/* harmony import */ var stanza_plugins_extdisco__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(stanza_plugins_extdisco__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var stanza_plugins_logging__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! stanza/plugins/logging */ "stanza/plugins/logging");
/* harmony import */ var stanza_plugins_logging__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(stanza_plugins_logging__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var stanza_plugins_pubsub__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! stanza/plugins/pubsub */ "stanza/plugins/pubsub");
/* harmony import */ var stanza_plugins_pubsub__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(stanza_plugins_pubsub__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var stanza_plugins_ping__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! stanza/plugins/ping */ "stanza/plugins/ping");
/* harmony import */ var stanza_plugins_ping__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(stanza_plugins_ping__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var whatwg_fetch_fetch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! whatwg-fetch/fetch */ "whatwg-fetch/fetch");
/* harmony import */ var whatwg_fetch_fetch__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(whatwg_fetch_fetch__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var stanza_browser_module__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! stanza/browser-module */ "stanza/browser-module");
/* harmony import */ var stanza_browser_module__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(stanza_browser_module__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var xmpp_jid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! xmpp-jid */ "xmpp-jid");
/* harmony import */ var xmpp_jid__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(xmpp_jid__WEBPACK_IMPORTED_MODULE_7__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JID", function() { return xmpp_jid__WEBPACK_IMPORTED_MODULE_7__["JID"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Client", function() { return stanza_browser_module__WEBPACK_IMPORTED_MODULE_6__["Client"]; });






 // eslint-disable-line



 // HACK: for some reason, in production builds of angular, the imports for these plugins are getting messed.
// A lot of time has been sunk into figuring out why/how to fix it properly, but to no avail. This is a
// harmless hack that works around the issue.

function getActualFunction(dep) {
  if (dep["default"]) {
    return dep["default"];
  }

  return dep;
}
function createClient(opts) {
  var client = new stanza_browser_module__WEBPACK_IMPORTED_MODULE_6__["Client"](opts);
  [stanza_plugins_disco__WEBPACK_IMPORTED_MODULE_0___default.a, // must be first
  stanza_plugins_extdisco__WEBPACK_IMPORTED_MODULE_1___default.a, stanza_plugins_logging__WEBPACK_IMPORTED_MODULE_2___default.a, stanza_plugins_pubsub__WEBPACK_IMPORTED_MODULE_3___default.a, stanza_plugins_ping__WEBPACK_IMPORTED_MODULE_4___default.a].map(function (plugin) {
    return client.use(getActualFunction(plugin));
  });
  return client;
}

/***/ }),

/***/ "./src/utils.js":
/*!**********************!*\
  !*** ./src/utils.js ***!
  \**********************/
/*! exports provided: requestApi, timeoutPromise, splitIntoIndividualTopics */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "requestApi", function() { return requestApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeoutPromise", function() { return timeoutPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitIntoIndividualTopics", function() { return splitIntoIndividualTopics; });
/* harmony import */ var superagent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! superagent */ "superagent");
/* harmony import */ var superagent__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(superagent__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _request_logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./request-logger */ "./src/request-logger.js");
/* harmony import */ var _request_logger__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_request_logger__WEBPACK_IMPORTED_MODULE_1__);



function buildUri(host, path) {
  var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'v2';
  path = path.replace(/^\/+|\/+$/g, ''); // trim leading/trailing /

  if (host.indexOf('http') === 0) {
    return "".concat(host, "/api/").concat(version, "/").concat(path);
  }

  return "https://api.".concat(host, "/api/").concat(version, "/").concat(path);
}

function requestApi(path, _ref) {
  var method = _ref.method,
      data = _ref.data,
      host = _ref.host,
      version = _ref.version,
      contentType = _ref.contentType,
      authToken = _ref.authToken,
      logger = _ref.logger;
  var response = superagent__WEBPACK_IMPORTED_MODULE_0___default.a[method](buildUri(host, path, version)).use(_request_logger__WEBPACK_IMPORTED_MODULE_1___default()(logger, data)).set('Authorization', "Bearer ".concat(authToken)).type(contentType || 'json');
  return response.send(data); // trigger request
}
function timeoutPromise(fn, timeoutMs, msg, details) {
  return new Promise(function (resolve, reject) {
    var timeout = setTimeout(function () {
      var err = new Error("Timeout: ".concat(msg));
      err.details = details;
      reject(err);
    }, timeoutMs);

    var done = function done() {
      clearTimeout(timeout);
      resolve();
    };

    fn(done, reject);
  });
}
function splitIntoIndividualTopics(topicString) {
  var topics = [];

  if (topicString.includes('?')) {
    var split = topicString.split('?');
    var prefix = split[0];
    var postfixes = split[1] && split[1].split('&');

    if (postfixes && postfixes.length) {
      postfixes.forEach(function (postfix) {
        topics.push("".concat(prefix, ".").concat(postfix));
      });
    }
  } else {
    topics.push(topicString);
  }

  return topics;
} // unsed, but handy. no test coverage until used
// function mergeOptions (destination, provided) {
//   for (var key in provided) {
//     let value = provided[key];
//     if (value instanceof Object) {
//       if (!destination[key]) {
//         destination[key] = {};
//       }
//       mergeOptions(destination[key], value);
//     } else {
//       destination[key] = provided[key];
//     }
//   }
//
//   return destination;
// }

/***/ }),

/***/ "@babel/runtime/helpers/classCallCheck":
/*!********************************************************!*\
  !*** external "@babel/runtime/helpers/classCallCheck" ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/classCallCheck");

/***/ }),

/***/ "@babel/runtime/helpers/createClass":
/*!*****************************************************!*\
  !*** external "@babel/runtime/helpers/createClass" ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/createClass");

/***/ }),

/***/ "@babel/runtime/helpers/defineProperty":
/*!********************************************************!*\
  !*** external "@babel/runtime/helpers/defineProperty" ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ "@babel/runtime/helpers/slicedToArray":
/*!*******************************************************!*\
  !*** external "@babel/runtime/helpers/slicedToArray" ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/slicedToArray");

/***/ }),

/***/ "@babel/runtime/helpers/toConsumableArray":
/*!***********************************************************!*\
  !*** external "@babel/runtime/helpers/toConsumableArray" ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/toConsumableArray");

/***/ }),

/***/ "backoff-web":
/*!******************************!*\
  !*** external "backoff-web" ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("backoff-web");

/***/ }),

/***/ "debounce-promise":
/*!***********************************!*\
  !*** external "debounce-promise" ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("debounce-promise");

/***/ }),

/***/ "genesys-cloud-streaming-client-webrtc-sessions":
/*!*****************************************************************!*\
  !*** external "genesys-cloud-streaming-client-webrtc-sessions" ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("genesys-cloud-streaming-client-webrtc-sessions");

/***/ }),

/***/ "limiter":
/*!**************************!*\
  !*** external "limiter" ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("limiter");

/***/ }),

/***/ "stanza/browser-module":
/*!****************************************!*\
  !*** external "stanza/browser-module" ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("stanza/browser-module");

/***/ }),

/***/ "stanza/plugins/disco":
/*!***************************************!*\
  !*** external "stanza/plugins/disco" ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("stanza/plugins/disco");

/***/ }),

/***/ "stanza/plugins/extdisco":
/*!******************************************!*\
  !*** external "stanza/plugins/extdisco" ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("stanza/plugins/extdisco");

/***/ }),

/***/ "stanza/plugins/logging":
/*!*****************************************!*\
  !*** external "stanza/plugins/logging" ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("stanza/plugins/logging");

/***/ }),

/***/ "stanza/plugins/ping":
/*!**************************************!*\
  !*** external "stanza/plugins/ping" ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("stanza/plugins/ping");

/***/ }),

/***/ "stanza/plugins/pubsub":
/*!****************************************!*\
  !*** external "stanza/plugins/pubsub" ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("stanza/plugins/pubsub");

/***/ }),

/***/ "superagent":
/*!*****************************!*\
  !*** external "superagent" ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("superagent");

/***/ }),

/***/ "whatwg-fetch/fetch":
/*!*************************************!*\
  !*** external "whatwg-fetch/fetch" ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("whatwg-fetch/fetch");

/***/ }),

/***/ "xmpp-jid":
/*!***************************!*\
  !*** external "xmpp-jid" ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("xmpp-jid");

/***/ })

/******/ })["default"];
}); 